import React from 'react';
import { Fab } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, useLocation } from 'react-router-dom';

export default function HomeFab({disabled = false}) {

  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/dashboard' || disabled) {
    return null;
  }

  const handleClick = () => {
    navigate('/dashboard'); // redirect to /dashboard
  };

  return (
    <Fab
      onClick={handleClick}
      color="primary"
      aria-label="add"
      sx={{
        position: 'fixed',
        bottom: -5,
        left: '50%', 
        transform: 'translateX(-50%)', 
        zIndex: 10000,
        opacity: 1,
        width: 50, 
        height: 50,
        minHeight: 50
      }}
    >
      <HomeIcon fontSize='large' />
    </Fab>
  );
}
